import { Button } from "@mui/material";
import { convertCamelCaseToDisplayText, convertToCamelCaseFromUnderScore } from "../../../../common-utilities/utils";

export const getHeaderConfig = (editVendor) => {
  const headers = [
    {
      label: "Id",
      id: "id"
    },
    {
      label: "Document Type",
      id: "documentType"
    },
    // {
    //   label: "Vendor Type",
    //   id: "typeOfVendor"
    // },
    {
      label: "Vendor Name",
      id: "nameOfVendor"
    },
    {
      label: "Vendor Address",
      id: "addressOfVendor"
    },
    {
      label: "Vendor Email",
      id: "emailIdOfVendor"
    },
    // {
    //   label: "Vendor Description",
    //   id: "descriptionOfBusinessOfVendor"
    // },
    // {
    //   label: "Service Scope Description",
    //   id: "descriptionOfScopeOfService"
    // },
    // {
    //   label: "Commercials Breakup",
    //   id: "breakupOfCommercials"
    // },
    // {
    //   label: "Time For Payment",
    //   id: "timeForPaymentOfInvoiceSubmission"
    // },
    // {
    //   label: "Pending On", id: "stage", render: data => {

    //     return convertToCamelCaseFromUnderScore(data?.currentStage) || "";
    //   }
    // }
  ];

  headers.push(
    // {
    //   label: "Created By",
    //   id: "creatorName"
    // },
    {
      label: "View",
      id: "view",
      render: (data) => {
        return (
          <>
            <div className='po-action-btns'>
              {/* <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  downloadPO(data);
                }}
              >
                <DownloadIcon
                  color='primary'
                  className='download-icon'
                  fontSize='medium'
                />
              </IconButton> */}

              <Button variant='text' onClick={() => editVendor(data, "VIEW")}>
                View
              </Button>
            </div>
          </>
        );
      }
    }
  );

  return headers;
};
